module.exports = __webpack_public_path__ + "a0129742d2a42f56af1481dfabc72efb.pdf";